<template>
  <div class="tipBar">
    <div class="tipBar__content" @click="tipClick">
      <div class="tipBar__content__text">
        <span class="tipBar__content__text__icon tipBar__content__icon" v-if="prefixIcon">
          <svg-icon :iconClass="prefixIcon"></svg-icon>
        </span>
        <span class="tipBar__content__text__text">{{ tipContent }}</span>
      </div>
      <div class="tipBar__content__close tipBar__content__icon" @click="tipClose">
        <svg-icon :iconClass="suffixIcon"></svg-icon>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TipsBar',
  props: {
    tipContent: {
      type: String,
      default: '',
    },
    tipClick: {
      type: Function,
      default: () => {},
    },
    tipClose: {
      type: Function,
      default: () => {},
    },
    prefixIcon: {
      type: String,
      default: '',
    },
    suffixIcon: {
      type: String,
      default: 'x',
    },
  },
}
</script>
<style lang="scss" scoped>
.tipBar {
  &__content {
    background-color: var(--heatgridTipBg);
    padding: 7px 10px;
    border-radius: 6px;
    display: flex;
    cursor: pointer;
    justify-content: space-between;
    align-items: center;
    &__icon {
      .svg-icon {
        width: 11px;
        height: 11px;
      }
    }
    &__text {
      display: flex;
      align-items: center;
      color: #9d9d9d;
      svg {
        margin-right: 4px;
      }
    }
    &__close {
      cursor: pointer;
      display: flex;
      align-items: center;
    }
  }
}
</style>
